<template>
  <base-share-button @click="click">
    <template #icon>
      <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="25" cy="25" r="25" fill="#A4DEF8" />
        <path
          d="M20.0003 30.5437L28.5294 36.7432C29.4986 37.2642 30.2035 37.0037 30.4502 35.8576L33.9217 19.7422C34.2742 18.3356 33.3755 17.7104 32.4415 18.1272L12.0703 25.8723C10.6781 26.428 10.6958 27.1921 11.8236 27.5221L17.0574 29.1371L29.1638 21.6177C29.7277 21.2704 30.2563 21.4614 29.8334 21.8435L20.0003 30.5437Z"
          fill="url(#paint0_linear_15904_55163)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_15904_55163"
            x1="25.1091"
            y1="26.9585"
            x2="29.4223"
            y2="33.9617"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#EFF7FC" />
            <stop offset="1" stop-color="white" />
          </linearGradient>
        </defs>
      </svg>
    </template>
    <template #title>
      {{ $t('social-share-buttons.telegram') }}
    </template>
  </base-share-button>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import BaseShareButton from '@vue-app/components/base/share/buttons/BaseShareButton.vue'

export default {
  name: 'TelegramShareButton',
  components: { BaseShareButton },
  methods: {
    click() {
      $emit(this, 'share', 'telegram')
    },
  },
  emits: ['share'],
}
</script>
